import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import styles from "./styles/Logout.module.scss";
// Common components
import ModalWrapper from "../../common/others/ModalWrapper";
import Button from "../../common/others/Button";
// Redux actions
import { logout } from "../../../redux/reducers/user";
// Utils
import icons from "../../../utils/icons";

const LogoutModal = ({ displayStatus, toggle }) => {
  // Hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // Functions
  function logoutUser() {
    dispatch(logout());
    navigate("/", { replace: true });
  }

  return (
    <ModalWrapper
      displayStatus={displayStatus}
      toggle={toggle}
      className={styles["logout-modal"]}
    >
      <button
        type={"button"}
        className={styles.close}
        onClick={() => toggle(false)}
      >
        {icons.cross}
      </button>

      <p className={styles.title}>خروج از حساب کاربری</p>
      <p className={styles.tip}>آیا می‌خواهید از حساب کاربری خود خارج شوید؟</p>

      <div className={styles.actions}>
        <button type={"button"} onClick={() => toggle(false)}>
          انصراف
        </button>

        <Button color={"red"} onClick={logoutUser}>
          خروج
        </Button>
      </div>
    </ModalWrapper>
  );
};

export default LogoutModal;
